import React from 'react';
import {
  Component,
  FilterCombo,
  PuzzleButton,
  Container,
  PuzzleInput,
  FieldWrap
} from "puzzle";
import {
  CUSTOM_FIELD_FILTER_ITEM,
  CUSTOM_FIELD_FILTER_SEARCH_DATA,
  NAME_VALUE,
  PROPS,
  SERVER_CUSTOM_FIELDS_FORMAT,
  STATE
} from "./Types"
import * as _ from "lodash";
import { Field } from "../../../UI/Field/Field";
import { translateCustomAttributes } from "../../../util/Util";

class CustomFieldsFilter extends Component<PROPS, STATE> {
  timer = 0;
  private initialState: any = {
    usedFilters: [],
    filterItems: [{}],
  };

  static defaultProps: PROPS = {
    customFieldsFilters: [],
    customAttributesValues: null,
    isSupplier: false,
    parentChange: () => {
    }
  };

  constructor(props: PROPS) {
    super(props);
    const items = this.generateStateFromProps();
    if (items.length) {
      this.state = {
        usedFilters: items.map((item: any) => item.filterName),
        filterItems: items,
      }
    } else {
      this.state = this.initialState;
    }
  }

  componentDidUpdate(prevProps: Readonly<any>): void {
    //props are changed only when change is made outside the component.
    if (!_.isEqual(prevProps.customAttributesValues, this.props.customAttributesValues)) {
      const items = this.generateStateFromProps();
      let object;
      const realState = this.state.filterItems.map((item: CUSTOM_FIELD_FILTER_ITEM) => {
        object = _.find(items, { 'filterName': item.filterName });
        return object || {
          filterName: item.filterName,
          value: null
        }
      });

      this.setState({
        usedFilters: realState.map((item: any) => item.filterName),
        filterItems: realState,
      })
    }
  };

  /**
   * Creates array of values from object
   */
  generateStateFromProps = () => {
    let customControlValues = _.isEmpty(this.props.customAttributesValues) ? [] : _.transform(this.props.customAttributesValues, function (acc: CUSTOM_FIELD_FILTER_ITEM[], value: string | null, key: string) {
      acc.push({ filterName: key, value: value });
    }, []);
    return customControlValues;
  };

  /**
   * Resets filter state
   */
  resetFilter = () => {
    this.setState(this.initialState)
  };

  /***
   * Load data to form
   * @param data
   */
  loadFiltersData = (data: CUSTOM_FIELD_FILTER_SEARCH_DATA) => {
    let valuesData;
    if (data.searchData) {
      valuesData = data.searchData && JSON.parse(data.searchData).customControlValues;
    } else if (data.customControlValues) {
      valuesData = data.customControlValues;
    }

    if (valuesData) {
      let parsedData = valuesData.map((item: any) => {
        return {
          filterName: item.name,
          value: item.value
        }
      });

      this.setState({
        filterItems: parsedData.length ? parsedData : [{}],
        usedFilters: parsedData.map((item: any) => item.filterName),
      })
    }
  };

  /**
   * Returns data from custom field filters
   */
  getCustomFiltersData = () => {
    const customFiltersData = this.state.filterItems.reduce((acc: NAME_VALUE[], item: any) => {
      if (!!item.value && item.filterName) {
        acc.push({
          name: item.filterName,
          value: item.value
        })
      }
      return acc;
    }, []);

    return customFiltersData;
  };

  /**
   * Appends custom fields filter data to existing filter data.
   * @param gridData
   */
  appendCustomAttributesData = (gridData: any) => {
    const customControlValues = this.getCustomFiltersData();
    return {
      ...gridData,
      ...(!gridData?.customControlValues && { customControlValues })
    }
  };

  /**
   * Custom field's render
   */
  renderAdditionalFilters = () => {
    let i = 0;
    let items = [];
    let data;
    const layoutConfig = this.props.isSupplier ? [6, 5, 1] : [4, 7, 1];
    while (i < this.state.filterItems.length) {

      data = this.props.customFieldsFilters.reduce((acc: NAME_VALUE[], item: SERVER_CUSTOM_FIELDS_FORMAT) => {
        if (!this.state.usedFilters.includes(item.name)) {
          acc.push({
            name: translateCustomAttributes(item.name),
            value: item.name
          })
        }
        return acc;
      }, []);
      if (this.state.filterItems[i]?.filterName) {
        let filterName = this.state.filterItems[i]?.filterName;
        data.unshift({
          name: translateCustomAttributes(filterName),
          value: filterName
        })
      }
      items.push((
        <FieldWrap key={'filterIndexWrapper' + i} layout={layoutConfig}>
          <Field>
            <FilterCombo
              key={'filterIndex' + i}
              id={'customFilterCombo_' + i}
              label={this.translate('filter')}
              data={data}
              value={this.state.filterItems[i]?.filterName || null}
              translateMethod={this.translate.bind(this)}
              onChange={this.onChange.bind(this, i)}
              textField='name'
              valueField='value'
              valueAsSimpleType={true}
            />
          </Field>
          <Field>
            {this.renderValueFiled(this.state.filterItems[i])}
          </Field>
          <Container
            alignItemsCenter
            hBox
            className={'tp-custom-field-action-btn-wrap'}
          >
            <PuzzleButton
              aria-label={this.translate('SRL-deleteCustomField')}
              disabled={this.state.filterItems.length === 1}
              iconClass={'tp-icon tp-icon-sm tp-close-circle'}
              fillMode='flat'
              size={'small'}
              onClick={this.deleteFilterItem.bind(this, i)}
            />
            <PuzzleButton
              aria-label={this.translate('SRL-addNewCustomField')}
              iconClass={'tp-icon tp-icon-sm tp-add-circle'}
              fillMode='flat'
              size={'small'}
              onClick={this.addFilterItem.bind(this, i)}
            />
          </Container>
        </FieldWrap>
      ));

      i++;
    }
    return items;
  };

  /**
   * Delete filter handler
   * @param index
   * @param e
   */
  deleteFilterItem = (index: number, e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    let { usedFilters } = this.state;
    let items = [...this.state.filterItems];

    let removedItem: any = items.splice(index, 1);
    if (removedItem[0].filterName) {
      usedFilters = usedFilters.filter((item: any) => item !== removedItem[0].filterName)
    }

    this.setState({
      filterItems: items,
      usedFilters
    }, this.deleteCallBack.bind(this, removedItem[0]));
  };

  /**
   * After item is removed from current component it will be removed SearchBar too.
   * @param removedItem
   */
  deleteCallBack = (removedItem: CUSTOM_FIELD_FILTER_ITEM) => {
    this.props.parentChange(removedItem.filterName, null, true);
  };

  /**
   * Add's new filter
   * @param index
   * @param e
   */
  addFilterItem = (index: number, e: React.MouseEvent) => {
    e.preventDefault();

    let items = this.state.filterItems;
    items.splice(index + 1, 0, { id: index });

    this.setState({
      filterItems: items,
    });
  };

  /**
   * On change handler, responsible for changes on name section.
   * @param index
   * @param e
   */
  onChange = (index: number, e: any) => {
    let items = [...this.state.filterItems];
    let hadValue = '';
    if (e.target.value === null) {
      index = this.state.filterItems.findIndex((element: any) => e.target.props.value === element.filterName);
      items[index] = {};
    } else {
      hadValue = items[index].filterName;
      items[index] = {
        filterName: e.target.value
      };
    }
    const usedFilters = items.reduce((acc: string[], item: CUSTOM_FIELD_FILTER_ITEM) => {
      if (item.filterName) {
        acc.push(item.filterName)
      }
      return acc;
    }, []);
    this.setState({
      usedFilters,
      filterItems: items
    }, this.nameChangeCallBack.bind(this, e.target.value, e.target.props.value, hadValue))
  };

  /**
   * After change on name part of custom field triggers value reset
   * @param value
   * @param previousValue
   * @param hadValue
   */
  nameChangeCallBack = (value: any, previousValue: any, hadValue: string) => {
    if (value === null) {
      this.props.parentChange(previousValue, null, true)
    } else if (hadValue) {
      this.props.parentChange(hadValue, null, true)
    }
  };

  /**
   * Responsible for changing value part of custom filed
   * @param item
   * @param e
   */
  valueChangeHandler = (item: CUSTOM_FIELD_FILTER_ITEM, e: any) => {
    let index = this.state.filterItems.findIndex((element: any) => item.filterName === element.filterName);
    let items = [...this.state.filterItems];

    items[index] = {
      ...items[index],
      value: e.value
    };

    this.setState({
      filterItems: items
    }, () => {
      clearTimeout(this.timer);
      (this.timer as any) = setTimeout(() => {
        this.props.parentChange(item.filterName, e.value, true)
      }, 300);
    })
  };

  /**
   * Renders value field part of custom fields
   * @param item
   */
  renderValueFiled = (item: CUSTOM_FIELD_FILTER_ITEM) => {
    if (item.filterName) {
      let filter = this.props.customFieldsFilters.find((obj: SERVER_CUSTOM_FIELDS_FORMAT) => obj.name === item.filterName);
      let translatedName = translateCustomAttributes(item.filterName);
      if (filter?.type === 'INPUT') {
        return (<PuzzleInput
          label={this.translate('filterName', { name: translatedName })}
          id={item.filterName}
          onChange={this.valueChangeHandler.bind(this, item)}
          value={item.value || ''}
        />)
      } else {
        //rip out values from server data
        const values = [...new Set(filter?.values.flat())];
        return (
          <FilterCombo
            label={this.translate('select', { name: translatedName })}
            data={values}
            onChange={this.valueChangeHandler.bind(this, item)}
            translateMethod={this.translate.bind(this)}
            value={item.value}
            valueAsSimpleType={true}
          />
        );
      }
    } else {
      return (<PuzzleInput
        id={`${item.id}-placeholder`}
        disabled
        label={this.translate('valueLabel')}
        value={''}
      />)
    }
  };

  render(): any {
    return (
      <div className={'tp-custom-fields-wrapper'}>
        <h3 className={'tp-custom-fields-label'}>{this.translate('customFieldsFilters')}</h3>
        {this.renderAdditionalFilters()}
      </div>
    );
  }
}

export default CustomFieldsFilter;
